<template>
  <div class="body_container">
    <Contact></Contact>
    <div class="width_margin">
      <div class="container_content_list_title">
        현채인/외국인<br />
        <span class="container_content_list_title_span"
          >대면 / 비대면(실시간 화상)</span
        >
      </div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication18.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#현지화 전략</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              해외법인 글로컬라이제이션 교육 솔루션
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            현지화 전략과 통합화 전략, 그리고 글로벌 리더십까지 현지 조직에
            최적화된 맞춤 솔루션을 제공합니다.
          </div>
          <div class="container_content_text_content">
            현채인 및 현지 직원의 역할 확대에 따른 역량 교육을 제공하여 본사
            비즈니스의 현지화, 통합화 전략 추구 목적<br />
            주재원의 성공적인 업무 수행을 위한 교육 솔루션과 심리 및 코칭 지원
            및 현지인에 대한 본사 교육 및 퍼실리테이션 교육 통해 동기부여<br />
            본사와 현지법인 간에 문제해결(PBL)을 위한 팀협업활동 플랫폼 및
            케이스 개발 연구를 통해 현채인과 본사의 효과적인 소통 및 교류 제고
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Global/ContactUs.vue";
export default {
  components: { Contact },
  name: "Foreigner",
};
</script>

<style></style>
